/* Bundle Wrapper — secondnaturesupplements.co.nz
 * /products/protein-creatine-bundle PDP: intercept cart-add and substitute
 * the selected flavor's underlying Shopify Bundle variant ID for the
 * wrapper variant ID. The wrapper never enters the cart; the real bundle does.
 */
(function () {
  var MAP = window.BUNDLE_FLAVOUR_MAP;
  if (!MAP) return;

  function getSelectedFlavor() {
    // Theme uses radio inputs with name="option1" for the Flavour option
    var checked = document.querySelector(
      'variant-picker input[name="option1"]:checked, input[name="option1"]:checked'
    );
    if (checked) return checked.value;
    var sel = document.querySelector('select[name="option1"], select[name="options[Flavour]"]');
    if (sel) return sel.value;
    return null;
  }

  function backendIdForFlavor(flavor) {
    if (!flavor) return null;
    if (MAP[flavor]) return MAP[flavor];
    var key = Object.keys(MAP).find(function (k) {
      return k.toLowerCase().trim() === String(flavor).toLowerCase().trim();
    });
    return key ? MAP[key] : null;
  }

  // --- Form submit (capture phase) ---
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var isProductForm = form.getAttribute('is') === 'product-form' || (form.action && form.action.indexOf('/cart/add') !== -1);
      if (!isProductForm) return;
      var flavor = getSelectedFlavor();
      var backendId = backendIdForFlavor(flavor);
      if (!backendId) return;
      // Try hidden input first
      var hidden = form.querySelector('input[name="id"]');
      if (hidden) { hidden.value = backendId; hidden.removeAttribute('disabled'); }
      // Theme may also use a <select name="id"> as the variant id source
      var sel = form.querySelector('select[name="id"]');
      if (sel) {
        // Ensure an <option> for the backend id exists; add it if not
        var opt = sel.querySelector('option[value="' + backendId + '"]');
        if (!opt) {
          opt = document.createElement('option');
          opt.value = backendId;
          opt.textContent = 'Bundle';
          sel.appendChild(opt);
        }
        sel.value = backendId;
      }
    },
    true
  );

  // --- Fetch interception (modern themes POST /cart/add.js via fetch) ---
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url && url.indexOf('/cart/add') !== -1 && init && init.body) {
        var flavor = getSelectedFlavor();
        var backendId = backendIdForFlavor(flavor);
        if (backendId) {
          if (typeof init.body === 'string') {
            try {
              var body = JSON.parse(init.body);
              if (body.id) body.id = backendId;
              if (Array.isArray(body.items)) {
                body.items = body.items.map(function (it) { return Object.assign({}, it, { id: backendId }); });
              }
              init.body = JSON.stringify(body);
            } catch (e) {
              if (init.body.indexOf('id=') !== -1) {
                init.body = init.body.replace(/(^|&)id=[^&]*/, '$1id=' + encodeURIComponent(backendId));
              }
            }
          } else if (init.body instanceof FormData) {
            if (init.body.has('id')) init.body.set('id', backendId);
          } else if (init.body instanceof URLSearchParams) {
            if (init.body.has('id')) init.body.set('id', backendId);
          }
        }
      }
    } catch (err) { console.warn('[bundle-wrapper] fetch error', err); }
    return origFetch.apply(this, arguments);
  };

  // --- XHR (older themes) ---
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__bw_cart_add = url && url.indexOf('/cart/add') !== -1;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (this.__bw_cart_add && body) {
        var flavor = getSelectedFlavor();
        var backendId = backendIdForFlavor(flavor);
        if (backendId) {
          if (typeof body === 'string') {
            try {
              var b = JSON.parse(body);
              if (b.id) { b.id = backendId; body = JSON.stringify(b); }
            } catch (e) {
              if (body.indexOf('id=') !== -1) {
                body = body.replace(/(^|&)id=[^&]*/, '$1id=' + encodeURIComponent(backendId));
              }
            }
          } else if (body instanceof FormData && body.has('id')) {
            body.set('id', backendId);
          }
          return origSend.call(this, body);
        }
      }
    } catch (err) { console.warn('[bundle-wrapper] xhr error', err); }
    return origSend.apply(this, arguments);
  };
})();
